import { useMemo } from 'react'

import { useInfiniteScrollQuerySimple } from 'hooks'

import Loading from 'components/Loading'
import LoadMore from 'components/LoadMore'

type InfiniteScrollList = {
  query: {
    useQuery: any
    args?: any
  }
  placeholder?: {
    title?: string
    message?: string
  }
  dataKey?: string
  paginationKey?: string
  nextPageKey?: string
  idKey?: string
  objKey?: string
  children: any
  groupMembersScroll?: boolean
}

const Placeholder = ({ title, message }: InfiniteScrollList['placeholder']) => (
  <div className="Placeholder">
    <h6 className="Placeholder__h6">{title}</h6>

    <p className="Placeholder__p">{message}</p>
  </div>
)

export const InfiniteScrollList = ({
  query,
  placeholder,
  dataKey,
  paginationKey,
  nextPageKey,
  idKey,
  children,
  groupMembersScroll, // This param exists because API related to group members handles pagination differently
  objKey, // Use if relevant ID key is within a nested object
}: InfiniteScrollList) => {
  const args = useMemo(() => query.args || {}, [query.args])

  const {
    isLoading,
    isFetching,
    hasMore,
    isEmpty,
    list,
    loadMore,
    loadMoreRef,
    setList,
    setListItem,
    data,
  } = useInfiniteScrollQuerySimple({
    useQuery: query.useQuery,
    args,
    dataKey,
    paginationKey,
    nextPageKey,
    idKey,
    objKey,
    groupMembersScroll,
  })

  return (
    <>
      {isLoading && <Loading />}

      {isEmpty && placeholder && <Placeholder {...placeholder} />}

      {children({ list, setList, setListItem, data })}

      <LoadMore
        ref={loadMoreRef}
        isLoading={isFetching}
        hidden={!hasMore}
        onClick={() => {
          loadMore()
        }}
      />
    </>
  )
}
